<template> 
    <v-carousel
        :continuous="true"
        :show-arrows="true"
        hide-delimiter-background
        cycle
        hide-delimiters
    
        delimiter-icon="mdi-minus"
        class='carousel'
        height="carouselHeight"
        min-height='500px'
    >
        
    <v-carousel-item class='coursel-item' v-if='banner.displayBanner'>
            <div class='image-wrapper d-flex flex-column flex-lg-row justify-space-between ' > 
                 <v-img 
                    :src="banner.imageUrl"
                    :max-width='imageWidth'
                    :height='imageHeight'
                    min-height='300px'
                    fill-width
                    href='/'>
                </v-img>
                <div class='image-side d-flex align-center flex-column'> 
                    <div class='header d-flex'> 
                       <span class='text-lg-h3 text-xl-h2 text-md-h4 text-sm-h5 text-h6 pt-lg-6 pt-xl-6'>  {{banner.header}} </span> 
                    </div>
                    <div class="body text-lg-subtitle-1 text-subtitle-2 pt-lg-11 pt-xl-10 pt-md-4 pt-sm-3"> {{banner.body}}</div>
                    <div class="button-div-flex  pb-lg-16 pb-md-9 pb-sm-7 pb-10 ">
                        <div><v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-none d-sm-flex"
                            outlined
                            color="black"
                            v-if="banner.showButton"
                            :to='banner.redirectUrl'
                            >
                            {{banner.buttonLabel}}
                        </v-btn>
                        
                        </div>
                    </div>
                </div>        
            </div>
        </v-carousel-item>
    
    <v-carousel-item class='coursel-item'>
            <div class='image-wrapper d-flex flex-column flex-lg-row justify-space-between ' > 
                 <v-img 
                    src='https://images.ctfassets.net/879w18cxw877/4rSmEzpWIWcdVewjvPrIur/a25eca9dba91976a6169a74e443d787c/1871s_and_ls.png?h=800' 
                    :max-width='imageWidth'
                    :height='imageHeight'
                    min-height='300px'
                    fill-width
                    href='/'>
                </v-img>
                <div class='image-side d-flex align-center flex-column'> 
                    <div class='header d-flex'> 
                       <span class='text-lg-h3 text-xl-h2 text-md-h4 text-sm-h5 text-h6 pt-lg-6 pt-xl-6'>  Check Out Our Newest Items </span> 
                    </div>
                    <div class="body text-lg-subtitle-1 text-subtitle-2 pt-lg-11 pt-xl-10 pt-md-4 pt-sm-3"> Browse and shop the latest arrivals at Global Furniture Florida and discover prododucts and collections for every room and style.</div>
                    <div class="button-div-flex  pb-lg-16 pb-md-9 pb-sm-7 pb-10 ">
                        <div><v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-none d-sm-flex"
                            outlined
                            color="black"
                            to='/livingroom/Living%20Room%20%20Sets'
                            >
                            Explore Our Living Room Collections
                        </v-btn>
                        <v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-sm-none d-flex text-center d-flex text-center"
                            outlined
                            color="black"
                            to='/livingroom/Living%20Room%20%20Sets' 
                            >
                            Explore Our <br>Living Room Collections
                        </v-btn>
                        
                        </div>
                    </div>
                </div>        
            </div>
        </v-carousel-item>
        
        <v-carousel-item class='coursel-item'>
            <div class='image-wrapper d-flex flex-column flex-lg-row justify-space-between' > 
                <v-img 
                src='https://images.ctfassets.net/879w18cxw877/49Bm8e80jCpTDtjlVZG6hc/aa16199c7476da95a0d032de010fcff0/Beverly_Hills__DT_1_6_62.jpg?h=800' 
                :max-width='imageWidth'
                :height='imageHeight'
                min-height='300px'
                fill-width
                href='/'>
                </v-img>   
                <div class='image-side d-flex align-center flex-column'> 
                    <div class='header d-flex'> 
                       <span class='text-lg-h3 text-xl-h2 text-md-h4 text-sm-h5 text-h6 pt-lg-6 pt-xl-6'>  Check Out Our Newest Items </span> 
                    </div>
                    <div class="body text-lg-subtitle-1 text-subtitle-2 pt-lg-11 pt-xl-10 pt-md-4 pt-sm-3"> Browse and shop the latest arrivals at Global Furniture Florida and discover prododucts and collections for every room and style.</div>
                    <div class="button-div-flex  pb-lg-16 pb-md-9 pb-sm-7 pb-10 ">
                        <div><v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-none d-sm-flex"
                            outlined
                            color="black"
                            to='/diningroom/Dining%20Room%20%20Sets'
                            >
                            Explore Our Dining Room Collections
                        </v-btn>
                        <v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-sm-none d-flex text-center"
                            outlined
                            color="black"
                            to='/diningroom/Dining%20Room%20%20Sets'
                            >
                            Explore Our <br>Dining Room Collections
                        </v-btn>
                        
                        </div>
                    </div>
                </div>    
            </div>
        </v-carousel-item>

         <v-carousel-item class='coursel-item'>
            <div class='image-wrapper d-flex flex-column flex-lg-row justify-space-between' > 
                <v-img 
                src='https://images.ctfassets.net/879w18cxw877/6ZQ2JJrbgiRsngnci8CinN/fb6d4ca606c5e35a58f3ceb7ebcc2cf0/PARIS_RSC_23.jpg?h=800' 
                :max-width='imageWidth'
                :height='imageHeight'
                min-height='300px'
                fill-width
                href='/'>
                </v-img>   
                <div class='image-side d-flex align-center flex-column'> 
                    <div class='header d-flex'> 
                       <span class='text-lg-h3 text-xl-h2 text-md-h4 text-sm-h5 text-h6 pt-lg-6 pt-xl-6'>  Check Out Our Newest Items </span> 
                    </div>
                    <div class="body text-lg-subtitle-1 text-subtitle-2 pt-lg-11 pt-xl-10 pt-md-4 pt-sm-3"> Browse and shop the latest arrivals at Global Furniture Florida and discover prododucts and collections for every room and style.</div>
                    <div class="button-div-flex  pb-lg-16 pb-md-9 pb-sm-7 pb-10 ">
                        <div><v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-none d-sm-flex"
                            outlined
                            color="black"
                            to='/bedroom/Bedroom%20Sets'
                            >
                            Explore Our Bedroom Collections
                        </v-btn>
                        <v-btn 
                            class="text-button card-button text-xs-caption text-lg-button d-sm-none d-flex text-center"
                            outlined
                            color="black"
                            to='/bedroom/Bedroom%20%20Sets'
                            >
                            Explore Our <br>Bedroom Collections
                        </v-btn>
                        
                        </div>
                    </div>
                </div>    
            </div>
        </v-carousel-item>
    </v-carousel>
</template>

<script>
    import axios from "axios"
    export default {
        name: 'Carousel',
        computed: {
            imageWidth () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return '100%'
                    case 'sm': return '100%'
                    case 'md': return '100%'
                    case 'lg': return '70%'
                    case 'xl': return '70%'
                }
            },
            carouselHeight () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return "65vh"
                    case 'sm': return "65vh"
                    case 'md': return "60vh"
                    case 'lg': return "70vh"
                    case 'xl': return '70vh'
                }
            },
            imageHeight () {
                switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return "30vh"
                    case 'sm': return "30vh"
                    case 'md': return "50vh"
                    case 'lg': return "70vh"
                    case 'xl': return '70vh'
                }
            },
                sideHeight()  {
                    switch (this.$vuetify.breakpoint.name) {
                    case 'xs': return "40vh"
                    case 'sm': return "50vh"
                    case 'md': return "60vh"
                    case 'lg': return "height=10vh"
                    case 'xl': return '70vh'
                    }
                }
            },
        data () {
                return {
                    banner: {},
                }
                },
                methods: {
                    async getBanner(bannerID){
                    let item
                    let res = await axios.get("https://cdn.contentful.com/spaces/879w18cxw877/environments/master/entries?content_type=banners&access_token=k2d5BXs_CQ-Px-3YCdr-S28UtighsicKk5qERY1JuYg")
                        .then(response => {
                            return response.data
                        })

                    res.items.forEach(banner => {
                        if(banner.fields.bannerId == bannerID){
                            item = banner.fields 
                        }
                        })
                    return item
                    }
                   
                },
                
                async created () {
                this.banner = await this.getBanner('Ban1')
                }
                    }
        
    
</script>

<style scoped> 
   .carousel {
        width: 85vw;
        margin-top: 3vh;
        
    }
   
   .image-wrapper{
        width: 100%;
        height: 100%;
    }

    .image-side {
        max-width: 100%;
        min-width: 30%;
        max-height: 1454px;
        min-height: 150px;
        background-color:#C0B1AE
    }
    .content-div-1 {
        height: 15%;
        width: 90%;
    
    }

    .content-div-2 {
        
        width: 90%;
        height:65%;
        position: relative
    }

    .button-flex {
        position:absolute;
        bottom:0;
        margin-right: auto;
        margin-left:auto;
    }

    .header {
        height:25%;
        width: 90%;
        text-align: center;
        justify-content: center;
        margin-top: 1vh;
    }
    .body {
        width: 90%;
        height: 60%;
        text-align: center;
    }

    .button-div-flex {
        width: 90%;
        height: 15%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    }
</style>